import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useHasPolicy = (policy:any) => {
    const {policies} = useSelector((state: any) => state.user);
    const [hasPolicy, setHasPolicy] = useState(false);
    useEffect(()=>{
            setHasPolicy(policies?.includes(policy));
    },[policies, policy])
    return hasPolicy;
}